import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const BUS_AUTOMATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusAutomation/";

export const busAutomationList = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(BUS_AUTOMATION_ROUTE + "list", {
    params,
    paramsSerializer: { indexes: null },
  });
};
